import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents1 from "../../Assets/Gulf_Students/GulfStudents.webp"
import GulfStudentsData from "../../Data/Gulf_Students/GulfStudentsData"
import "../CSS/GulfStudentsCSS.css"
import "../CSS/GulfStudentsForm.css"

const GulfStudents = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [destination, setDestination] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !destination) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            alert("Please enter a valid email address!");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('academic-readiness-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setDestination('');
                navigate('/gulf-students-success');
            })
            .catch((error) => console.log(error));
    };
    const withValidation = (regex, setter) => (e) => {
        const val = e.target.value;
        if (regex.test(val) || val === "") {
            setter(val);
        }
    };

    const onlyAlphabets = (setter) => withValidation(/^[A-Za-z\s]*$/, setter);

    const onlyEmail = (setter) => withValidation(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, setter);
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Gulf Students</title>
                {/* <meta name="description" content="Welcome to Holistic Learning, your destination for content writing career opportunities in Bangalore." /> */}
                <link rel="canonical" href="https://holisitclearning.com/gulf-students" />
            </Helmet>
            <section className="gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 gulf-students-heading-and-para-div">
                            <div className="gulf-students-heading-and-para-first-inner-div">
                                <h2>Supporting Gulf Students on Their <span>Journey to Foreign Universities</span></h2>
                                <p>Holistic Learning’s Gulf Students hub is your trusted companion for preparing to study in the U.S., UK, Canada, Australia, and beyond. From visa checklists and packing guides to academic bootcamps, mentorship networks, and career prep kits—we offer everything you need to thrive abroad. Built for Gulf nationals, backed by alumni insights, and designed to make your transition smooth, confident, and successful. Start your journey today.</p>
                            </div>
                        </div>
                        <div className="col-md-6 gulf-students-image-div">
                            <img src={GulfStudents1} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 planning-to-study-abroad-heading-div">
                            <h2>Planning To <span>Study Abroad?</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-md-12 planning-to-study-abroad-card-div">
                            <div className="planning-to-study-abroad-card-inner-div">
                                <p>Whether you're preparing to leave or have just landed, this space is built for you—Gulf students navigating the transition to American universities.</p>
                                <p>At Holistic Learning, we offer tailored support to help you thrive academically, socially, and professionally. No shortcuts. Just smart strategies, trusted resources, and a community that understands your journey.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 planning-to-study-abroad-heading-div">
                            <h2>Get Your <span>Free Study Abroad</span> Starter Pack</h2>
                            <h4>Includes: Departure Checklist, Academic Planner, Mentorship Onboarding Guide, Scholarship Tracker, And More...</h4>
                        </div>
                        <div className="col-md-12 contact-now-form">
                            <form name="gulf-students-form" id="gulf-students-form" method="post" action="academic-readiness-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="gulf-students-form" />
                                <div className="row justify-content-center">
                                    <div className="col-sm-6 col-md-4 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={onlyAlphabets(setStuName)} />
                                    </div>
                                    <div className="col-sm-6 col-md-4 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={onlyEmail(setEmail)} />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="departure" className="form-label">Destination Country</label>
                                        <input type="text" className="form-control" id="departure" name='departure' value={destination} onChange={onlyAlphabets(setDestination)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div download-starter-pack-button-div">
                                        <button type="submit">Download My Starter Pack</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="why-sign-up-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 why-sign-up-heading-div">
                            <h2>Why <span>Choose Us</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-md-4 why-sign-up-card-div">
                            <div className="why-sign-up-card-inner-div">
                                <p>Get early access to webinars, toolkits, and mentorship programs</p>
                            </div>
                        </div>
                        <div className="col-md-4 why-sign-up-card-div">
                            <div className="why-sign-up-card-inner-div">
                                <p>Receive personalized tips based on your destination and field of study</p>
                            </div>
                        </div>
                        <div className="col-md-4 why-sign-up-card-div">
                            <div className="why-sign-up-card-inner-div">
                                <p>Stay informed with visa updates, academic deadlines, and scholarship alerts</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="our-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 our-services-heading-div">
                            <h2>Our <span>Services</span></h2>
                            <h4>Explore our student-first services - each designed to ease your transition and accelerate your success.</h4>
                            <h5>From visa checklists to academic bootcamps, mentorship networks to career prep kits—Holistic Learning offers everything Gulf students need to thrive abroad. No shortcuts. Just smart strategies, trusted resources, and a community that understands your journey.</h5>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-5">
                        {
                            GulfStudentsData.map((item) => {
                                return (
                                    <div className="col our-services-card-div" key={item.id}>
                                        <div className="our-services-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <h5>{item.heading}</h5>
                                            <p>{item.text}</p>
                                            {item.link}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default GulfStudents